import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ClientService {
  public modal$: Observable<any>;
  private modalNameSubject: Subject<any>;

  constructor() {
    this.modalNameSubject = new Subject<any>();
    this.modal$ = this.modalNameSubject.asObservable();
  }

  //This is for the slideout nav
  

  //TODO: Remove the client modal altogether
  add(modalName: string, data?: any) {
    var modalObj = {
      modalName: modalName || '',
      data: data || {}
    }
    this.modalNameSubject.next(modalObj);
  }

  close(){
    var modalObj = {
      modalName: 'close-now',
      data: {}
    }
    this.modalNameSubject.next(modalObj);
  }
}